// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_ImportarCsvResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /despesas/importar_csv
 *
 * Batch import result for despesas from CSV data.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Despesas_ImportarCsvResponseDados {
successCount: number
errorCount: number
errors: string[]
message: string
}

export type Despesas_ImportarCsvResponse = ApiResponse<Despesas_ImportarCsvResponseDados>;

registerResponseContract('Despesas_ImportarCsvResponse', {
  successCount: { type: 'number',  required: true },
  errorCount:   { type: 'number',  required: true },
  errors:       { type: 'array',   required: true },
  message:      { type: 'string',  required: true },
})
